var exports = {
  "kL": "NotFoundPage.module__container___TzY4Y2",
  "Kk": "NotFoundPage.module__icon___TzY4Y2",
  "Qs": "NotFoundPage.module__content___TzY4Y2",
  "DD": "NotFoundPage.module__title___TzY4Y2",
  "h_": "NotFoundPage.module__description___TzY4Y2",
  "o1": "NotFoundPage.module__actions___TzY4Y2",
};

module.exports = exports;
